import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import PrivacyPolicyMain from './components/PrivacyPolicyMain';
import DailyFlowPrivacyPolicy from './components/DailyFlowPrivacyPolicy';
import KomunityPrivacyPolicy from './components/KomunityPrivacyPolicy';
import YikjeolBotPrivacyPolicy from './components/YikjeolBotPrivacyPolicy';
import EquityNotePrivacyPolicy from './components/EquityNotePrivacyPolicy';
import CSAEPolicy from './components/CSAEPolicy.js';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PrivacyPolicyMain />} />
        <Route path="/dailyflow-privacyPolicy" element={<DailyFlowPrivacyPolicy />} />
        <Route path="/komunity-privacyPolicy" element={<KomunityPrivacyPolicy />} />
        <Route path="/yikjeolbot-privacyPolicy" element={<YikjeolBotPrivacyPolicy />} />
        <Route path="/EquityNote-privacyPolicy" element={<EquityNotePrivacyPolicy />} />
        <Route path="/csae-policy" element={<CSAEPolicy />} />
      </Routes>
    </Router>
  );
};

export default App;